import { INITIALIZING_STEP } from "consts";

export const ORG_ONBOARDING_STEPS = {
  [INITIALIZING_STEP]: INITIALIZING_STEP,
  DEPLOYMENT: "DEPLOYMENT",
  PERMISSIONS: "PERMISSIONS",
  ONBOARDING: "ONBOARDING",
};
